/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';

export interface IMPPS {
  id?: string;
  accessionNo?: string;
  createdTime?: number;
  ppsStartDate?: number;
  ppsStartTime?: number;
  sopIuid?: string;
  ppsStatus?: number;
  studyIuid?: string;
  updatedTime?: number;
  dicomAttrs?: string;
  discreasonCode?: string | null;
  patient?: IGlucoUser | null;
  accnoIssuer?: IDiagLab | null;
}

export const defaultValue: Readonly<IMPPS> = {};
